import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Checkout from './Pages/buyer/Checkout'
import Invoice from './Pages/buyer/Invoice'
import Landing from './Pages/common/Landing'
import Login from './Pages/seller/Login'
import Inventory from './Pages/seller/Inventory'
import Register from './Pages/seller/Register'
import Shopping from './Pages/common/Shopping'
import SignIn from './Pages/buyer/SignIn'
import SignUp from './Pages/buyer/SignUp'
import AboutUs from './Pages/common/AboutUs'
import Contact from './Pages/common/Contact'
import OrderHistory from './Pages/buyer/OrderHistory'
import LogOut from './components/LogOut'
import BuyerProtectedRoutes from './components/protectedRoutes/BuyerProtectedRoutes'
import SellerProtectedRoutes from './components/protectedRoutes/SellerProtectedRoutes'
import Auth from './Pages/admin/Auth'
import Admin from './Pages/admin/Admin'
import Buyer from './Pages/admin/Buyer'
import Seller from './Pages/admin/Seller'
import Product from './Pages/admin/Product'
import Order from './Pages/admin/Order'
import ProductDetails from './Pages/common/ProductDetails'
import AdminProtectedRoutes from './components/protectedRoutes/AdminProtectedRoutes'
import Feedback from './Pages/admin/Feedback'
import Return from './Pages/common/Return'
import SellerProfile from './Pages/seller/Profile'
import BuyerProfile from './Pages/buyer/Profile'


const App = () => {
  return (
    <div className='font-poppins dark:bg-black dark:text-white'>
      <Routes>
        <Route path="/sign-out" element={<LogOut />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/about' element={<AboutUs />} />
        <Route path="/shop" element={<Shopping />} />
        <Route path="/register-seller" element={<Register />} />
        <Route path="/login" element={<SignIn />} />
        <Route path='/login-seller' element={<Login />} />
        <Route path="/register" element={<SignUp />} />
        <Route path="/" element={<Landing />} />
        <Route path='/dp/:productId' element={<ProductDetails />} />
        <Route path='/return' element={<Return />} />

        <Route element={<SellerProtectedRoutes />} >
          <Route path="/inventory" element={<Inventory />} />
          <Route path='seller/profile' element={<SellerProfile />} />
        </Route>

        <Route element={<BuyerProtectedRoutes />} >
          <Route path="/orders" element={<OrderHistory />} />
          <Route path='buyer/profile' element={<BuyerProfile />} />
          <Route path='/invoice/:orderId' element={<Invoice />} />
          <Route path="/invoice" element={<Invoice />} />
          <Route path="/checkout" element={<Checkout />} />
        </Route>

        <Route path="/admin" element={<Auth />} />
        <Route element={<AdminProtectedRoutes />} >
          <Route path="/admin/dashboard" element={<Admin />} />
          <Route path="/admin/buyer-list" element={<Buyer />} />
          <Route path="/admin/seller-list" element={<Seller />} />
          <Route path="/admin/product-list" element={<Product />} />
          <Route path="/admin/order-list" element={<Order />} />
          <Route path="/admin/feedback-list" element={<Feedback />} />
        </Route>
      </Routes>
    </div>
  )
}

export default App